export enum TotalCostsCode {
    KoA_INVESTMENT_COSTS = 'KoA',
    KoE_PRODUCTION_COSTS = 'KoE',
    KoB_CONSTRUCTION_FACILITY_COSTS = 'KoB',
    KoG_BUILDING_COSTS = 'KoG',
}
